import React from "react";
import LeftNav from "../components/5-left-nav";
import JourneyPlanner from "../components/7-journey-planner";
import Footer from "../components/9-contact-footer";

const JP = () => {
  return (
    <div>
      <LeftNav />
      <JourneyPlanner />
      <Footer />
    </div>
  );
};

export default JP;
